import { useQuery } from '@tanstack/react-query';
import { ManifestApiResponse } from '@manifest-cyber/types/interface/apiResponse';
import { LicenseData } from '../types/licenseData.interface';
import { AxiosProxy } from '../../../../api/axiosProxy/axiosProxy';

export const useLicenses = () => {
  return useQuery({
    queryKey: ['licenses'],
    queryFn: async (): Promise<ManifestApiResponse<LicenseData[]>> => {
      // The API endpoint doesn't support pagination, sorting, or search parameters
      // It returns all licenses and we'll handle filtering/sorting client-side
      return await AxiosProxy.get({
        url: 'licenses',
      });
    },
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
};
